import { serializeJsonLd } from '../lib/json_ld'

type Props = Readonly<{
  data: unknown
}>

// Renders in the component tree (not via useEffect) so a later renderToString
// prerender keeps the script in the first HTML response.
const JsonLd = ({ data }: Props) => {
  if (!data) return null

  return (
    <script
      type="application/ld+json"
      suppressHydrationWarning
      dangerouslySetInnerHTML={ { __html: serializeJsonLd(data) } }
    />
  )
}

export { JsonLd }
